import { ProcessSection, NetworkSection, FaqSection } from "@/components/Sections";
import CTASection from "@/components/CTASection";
import useSEO from "@/lib/useSEO";

export default function HowItWorks() {
  useSEO({
    title: "How it works | Upload Counsel",
    description: "Send one request. A licensed attorney reviews it, tells you whether you need a lawyer, and matches you with vetted counsel licensed where you need them. Scope and price in writing first.",
    canonical: "https://uploadlawyer.com/how-it-works",
  });
  return (
    <div data-testid="page-how">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 glow-tl" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-12 md:pt-24">
          <p className="eyebrow">How it works</p>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl text-[#F4F1EA] max-w-4xl leading-[1.02]">
            One request. <span className="italic text-[#D9B36C]">The right lawyer.</span>
          </h1>
          <p className="mt-6 text-slate-300 text-lg sm:text-xl max-w-2xl leading-relaxed">
            You shouldn't need to research lawyers every time something goes wrong. Tell us once; we work out who should handle it.
          </p>
        </div>
      </section>
      <ProcessSection id="steps" />
      <NetworkSection />
      <FaqSection />
      <CTASection title="Ready when you are." body="Free to ask, reviewed by a licensed attorney, and we aim to reply within one business day." />
    </div>
  );
}
